// extracted by mini-css-extract-plugin
var _1 = "ReportLegend__colorSquare--QJD30 ReportLegend__icon--NPHaW";
var _2 = "ReportLegend__icon--NPHaW";
var _3 = "ReportLegend__keyItem--Oa4mo";
var _4 = "ReportLegend__main--BY5Iw";
export { _1 as "colorSquare", _2 as "icon", _3 as "keyItem", _4 as "main" }
